'use client' 

import { useRef, useEffect } from 'react'

import { useParams, useRouter, usePathname } from 'next/navigation'

import { TextInput } from "flowbite-react"
import { useDebouncedCallback } from 'use-debounce'

import { useTranslations } from '@/hooks/useTranslations'

import { IconSearch } from '../Icon'

const Search = () => {

    const ref = useRef<HTMLInputElement>(null)
    const t = useTranslations('search')
    const { locale, query } = useParams<{locale: string, query: string}>()
    const { push } = useRouter()
    const pathname = usePathname()

    const handleSearch = useDebouncedCallback((term: string) => {
        term.length >= 2 && push(`/${locale}/search/${slugify(term)}`)
    }, 500)

    useEffect(() => {
        if (pathname.includes('search')) {
            ref.current?.focus()
        }
    }, [pathname])

    return (
        <li className='flex items-center md:!ml-auto md:order-last'>
            <form onSubmit={e => e.preventDefault()} className='w-full'>
                <TextInput
                    ref={ref}
                    id="search-query"
                    data-testid="search-query"
                    name="query" 
                    sizing='sm'
                    autoComplete='off'
                    placeholder={t('button')} 
                    rightIcon={IconSearch}
                    onChange={(e) => handleSearch(e.target.value)}
                    defaultValue={ deslugify(query) }
                    key={query}
                    theme={inputTheme}
                    color="search"
                />
            </form>
        </li>
    )
}

const inputTheme = {
    "field": {
    "rightIcon": {
        "base": "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 md:pr-4",
        },
      "input": {
        "colors": {
          "search": "bg-[#2b2b2b] min-w-[210px] text-white placeholder-white !text-sm focus:!shadow-none focus:!ring-transparent !rounded-none !border-none !border-bottom-1 !p-4 md:!p-2 md:!px-3 md:!pr-10 uppercase"
        },
      }
    }
  }

const slugify = (str: string) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');

const deslugify = (str: string) => 
    str?.replaceAll('-', ' ') || ''

export default Search